/* eslint-disable */
import { useState, useEffect, useMemo } from "react";
import {sortBy} from "lodash"
import { useIntl } from "react-intl";
import { dictionariesService } from "../dependencyInjection";
import { Department } from "../services/DictionariesService";
import { RequestStatus } from "../../shared";
import { unsubscribe } from "../../../../utils";
import { localeService } from "../../../locale/dependencyInjection";
import messages from "../../constants/messages";

type UseDepartmentsResult = [Department[], Department[], RequestStatus];

export function useDepartments(): UseDepartmentsResult {
  const [departmentsDict, setDepartmentsDict] = useState<Department[]>(dictionariesService.departments);
  const [status, setStatus] = useState(RequestStatus.None);
  const intl = useIntl();

  useEffect(() => {
    const subDepartments = dictionariesService.departments$.subscribe((departments) => {
      setDepartmentsDict(departments);
    });
    const subStatus = dictionariesService.status$.subscribe((code) => {
      setStatus(code);
    });
    return unsubscribe(subDepartments, subStatus);
  }, []);

  const getDepartmentsDictionary = useMemo(
    () => async () => {
      try {
        await dictionariesService.getDepartmentsDictionary();
      } catch (e) {}
    },
    [],
  );

  const setDepartmentsNamesDeleted = () => {
    let newDepartmentsList: Department[] = [];
    if (intl && departmentsDict.length) {
      newDepartmentsList = departmentsDict.map((item) => {
        let name = "";
        if (item.name && !item.name.includes(`[${intl.formatMessage(messages.deleted)}]`)) {
          name = item.isDeleted ? `${item.name} [${intl.formatMessage(messages.deleted)}]` : item.name;
        }
        return { ...item, name: name ? name : item.name };
      });
    }
    const sortedList = sortBy(newDepartmentsList, (item) => item.name.toLowerCase())
    return sortedList;
  };

  useEffect(() => {
    getDepartmentsDictionary();
  }, []);

  const departmentsWithNamesDeleted = setDepartmentsNamesDeleted();

  return [departmentsDict, departmentsWithNamesDeleted, status];
}
